import React from 'react';
import {SelectFieldAdapter} from "./SelectFieldAdapter";
import type {SelectFieldAdapterProps} from "./SelectFieldAdapter";

export const SearchableSingleSelectField: React.FC<Omit<SelectFieldAdapterProps, 'isMulti'>> = (props) => {
    return <SelectFieldAdapter
        {...props}
        isMulti={false}
    />;
};
